import { render, staticRenderFns } from "./OverlayTdt.vue?vue&type=template&id=4d0742d1"
import script from "./OverlayTdt.vue?vue&type=script&lang=js"
export * from "./OverlayTdt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports